// Let Chart.js resize the canvas; only reduce label density when space is limited.
export default function treasuryChartResize(chart, { width }) {
    const ticks = chart.options.scales?.x?.ticks;
    if (ticks) {
        ticks.autoSkip = true;
        ticks.maxTicksLimit = Math.max(2, Math.floor(width / 65));
        ticks.maxRotation = width <= 480 ? 0 : 45;
    }
    if (chart.options.scales?.y?.ticks) chart.options.scales.y.ticks.maxTicksLimit = 6;
    const legend = chart.options.plugins?.legend?.labels;
    if (legend) {
        legend.padding = width <= 480 ? 10 : 20;
        legend.boxWidth = 10;
        legend.boxHeight = 10;
    }
}
